import {createContext, useCallback, useContext, useState} from "react";

const PopupContext = createContext();

export const usePopup = () => {
  return useContext(PopupContext);
};

export const PopupProvider = ({children}) => {
  const [popupContent, setPopupContent] = useState({
    content: null,
    closeButton: true,
    onClose: null,
  });

  const openPopup = useCallback((content, options = {closeButton: true}) => {
    setPopupContent({
      content,
      closeButton: options.closeButton ?? true,
      onClose: options.onClose || null,
    });
  }, []);

  const closePopup = useCallback(() => {
    setPopupContent({content: null, closeButton: true, onClose: null});
  }, []);

  return (
    <PopupContext.Provider value={{popupContent, openPopup, closePopup}}>
      {children}
    </PopupContext.Provider>
  );
};
